<template>
  <div class="main-content" id="panel">
    <!-- Header -->
    <!-- <Header /> -->
    <!-- Header -->
    <div class="header bg-primary pb-6">
      <div class="container-fluid">
        <div class="header-body">
          <div class="row align-items-center py-4">
            <div class="col-lg-6 col-7">
              <h2>Change Password</h2>
              <nav aria-label="breadcrumb" class="d-none d-md-inline-block" v-if="$route.matched[0].name != 'BidSide'">
                <ol class="breadcrumb breadcrumb-links breadcrumb-dark">
                  <li class="breadcrumb-item">
                    <i class="fas fa-home"></i>
                  </li>
                  <li class="breadcrumb-item">Manage Users</li>
                  <li class="breadcrumb-item active" aria-current="page">Change Password</li>
                </ol>
              </nav>
            </div>
            <div class="col-lg-6 col-5 text-right"></div>
          </div>
          <!-- Card stats -->
        </div>
      </div>
    </div>
    <!-- Page content -->
    <div class="container-fluid mt--6">
      <div class="row justify-content-md-center upload">
        <div class="col-xl-5">
          <div class="card">
            <div class="card-header bg-transparent">
              <div class="row align-items-center">
                <div class="col">
                  <h3>Change Password</h3>
                </div>
              </div>
            </div>
            <div class="card-body">
              <form role="form">
                <div class="form-group mb-3">
                  <div class="input-group input-group-merge input-group-alternative">
                    <div class="input-group-prepend">
                      <span class="input-group-text">
                        <i class="fa fa-unlock-alt" aria-hidden="true"></i>
                      </span>
                    </div>
                    <input
                      class="form-control"
                      type="password"
                      placeholder="Current Password"
                      v-model="currentpassword"
                    />
                  </div>
                </div>
                <div class="form-group mb-3">
                  <div class="input-group input-group-merge input-group-alternative">
                    <div class="input-group-prepend">
                      <span class="input-group-text">
                        <i class="fa fa-unlock-alt" aria-hidden="true"></i>
                      </span>
                    </div>
                    <input
                      class="form-control"
                      type="password"
                      placeholder="New Password"
                      v-model="newpassword"
                    />
                  </div>
                </div>
                <div class="form-group">
                  <div class="input-group input-group-merge input-group-alternative">
                    <div class="input-group-prepend">
                      <span class="input-group-text">
                        <i class="fa fa-unlock-alt" aria-hidden="true"></i>
                      </span>
                    </div>
                    <input
                      class="form-control"
                      placeholder="Confirm Password"
                      type="password"
                      v-model="confirmpassword"
                    />
                  </div>
                </div>
                <br />
                <div v-if="error.message" class="alert alert-danger" role="alert">
                  <i class="fas fa-exclamation-triangle"></i>
                  {{error.message}}
                </div>
                <div class="alert alert-success" role="alert" v-if="passwordChanged">
                  <i class="fas fa-check-circle"></i>
                  Password changed successfully.
                </div>
                <div class="text-center">
                  <button type="submit" class="btn btn-primary my-2" @click="change">
                    CHANGE PASSWORD
                    <i
                      v-if="!loading"
                      class="fa fa-arrow-circle-right"
                      aria-hidden="true"
                    ></i>
                    <i v-if="loading" class="fa fa-spinner fa-spin" aria-hidden="true"></i>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <!-- Footer -->
      <!-- <Footer /> -->
    </div>
  </div>
</template>
<script>
// import Header from "../common/Header";
// import Footer from "../common/Footer";
//import config from "@/config";
//import stateConstants from "@/stateConstants";
// import DataTable from 'datatables'
/* eslint-disable no-unused-vars */

// import $ from "jquery";
import config from "@/config";
import authService from "@/authService";

export default {
  name: "viewdata",
  components: {
    // Header,
    // Footer
  },
  data() {
    return {
      accessToken: null,
      users: [],
      config: config,
      currentpassword: "",
      newpassword: "",
      confirmpassword: "",
      error: {},
      loading: false,
      passwordChanged: false,
      cognitoidentityserviceprovider: null
    };
  },
  created() {
    this.user = this.$cognitoAuth.getCurrentUser();
    this.$cognitoAuth.getIdToken((err, result) => {
      if (err) {
        this.error = err;
      } else {
        this.accessToken = result;
      }
    });
    // const userPoolLoginKey = config.userPoolLoginKey;
    // const logins = {};
    // logins[userPoolLoginKey] = this.accessToken;
    // AWS.config.region = config.region;
    // const cognitoParams = {
    //   IdentityPoolId: config.IdentityPoolIdFileUpload,
    //   Logins: logins
    // };
    // this.cognitoidentityserviceprovider = new AWS.CognitoIdentityServiceProvider(
    //   {
    //     region: "us-east-1",
    //     credentials: new AWS.CognitoIdentityCredentials(cognitoParams)
    //   }
    // );
    // cognitoidentityserviceprovider.listUsers(
    //   { UserPoolId: "us-east-1_lPsGMCeW4" },
    //   (err, data) => {
    //     if (err) {
    //       console.log(err);
    //     } else {
    //       this.users = data.Users;
    //     }
    //   }
    // );
    
    
  },
  methods: {
    setUserLastPasswordReset(){
      let user = authService.getUser();
      let dataToSend = {"username": user.email}
      const auth = {
          headers: { }
      };
      this.$http.post(config.baseUrlLamda,dataToSend,auth)
      .then(() => {
        // Step 1: Get the user object from localStorage
        const user = JSON.parse(localStorage.getItem('user'));
        // Step 2: Delete the 'lastPasswordChange' property
        delete user.lastPasswordChange;
        // Step 3: Save the updated object back to localStorage
        localStorage.setItem('user', JSON.stringify(user));
        window.location.href = '/dashboardoption';

      })

    },
    getEmailFromAttr(data) {
      //console.log(data);
      var obj = data.find(res => res.Name == "email");
      if (obj) {
        return obj.Value;
      } else {
        return "Email is not added";
      }
    },
    change(e) {
      e.preventDefault();
      this.error = { message: "" };
      if (
        this.newpassword == "" ||
        this.confirmpassword == "" ||
        this.currentpassword == ""
      ) {
        this.error = {
          message:
            "Current password,New password and confirm password is required"
        };
        return false;
      }
      if (this.newpassword == this.confirmpassword) {
        var params = {
          AccessToken: this.accessToken /* required */,
          PreviousPassword: this.currentpassword /* required */,
          ProposedPassword: this.newpassword /* required */
        };
        this.loading = true;
        var self = this;
        if (this.user != null) {
          this.user.getSession(function(err, data) {
            if (err) {
              alert(err);
              return;
            } else {
              console.log("data", data);
            }
          });

          this.user.changePassword(
            this.currentpassword,
            this.newpassword,
            function(err, data) {
              if (err) {
                self.error = err;
                console.log(err);
                self.loading = false;
              } else {
                self.loading = false;
                self.passwordChanged = true;
                self.setUserLastPasswordReset()
              }
            }
          );
        }
        // this.$cognitoAuth.changePassword(
        //   this.currentpassword,
        //   this.newpassword,
        //   err => {
        //     if (err) {
        //       //console.log("login error",err);
        //       this.error = err;
        //       this.loading = false;
        //     } else {
        //       alert("Password changed successfully");
        //       // this.loading = false;
        //       // this.$router.push("/dashboard");
        //     }
        //   }
        // );
        // this.cognitoidentityserviceprovider.changePassword(params, function(
        //   err,
        //   data
        // ) {
        //   if (err){
        //       this.error = err;
        //       this.loading = false;
        //       console.log(err, err.stack);
        //   }
        //   // an error occurred
        //   else {
        //       this.loading = false;
        //       //alert("Password reset successfully. Please login with your new password ");
        //       console.log(data);
        //       } // successful response
        // });
      } else {
        this.error = {
          message: "New password and confirm password do not match"
        };
      }
    }
  },
  mounted() {}
};
</script>
<style scoped>
</style>